<template>
  <div class="member-manage">
    <el-card class="box-card" shadow="never">
      <div slot="header" class="clearfix">
        <span>会员管理</span>
      </div>
      <!-- 搜索条件（自定义检索下拉形式） -->
      <el-form :inline="true" :model="search" size="small" class="search-form">
        <el-form-item label="自定义检索">
          <el-select v-model="searchType" placeholder="请选择" @change="handleSearchTypeChange">
            <el-option label="按公司名称" value="1" />
            <el-option label="按用户名" value="2" />
            <el-option label="按手机号码" value="3" />
            <el-option label="按注册时间" value="4" />
            <el-option label="按平台名称" value="5" />
            <el-option label="按状态" value="6" />
          </el-select>
        </el-form-item>

        <el-form-item v-if="searchType === '1'">
          <el-input v-model="search.company_name" placeholder="公司名称" clearable />
        </el-form-item>

        <el-form-item v-if="searchType === '2'">
          <el-input v-model="search.username" placeholder="用户名" clearable />
        </el-form-item>

        <el-form-item v-if="searchType === '3'">
          <el-input v-model="search.mobile" placeholder="手机号码" clearable />
        </el-form-item>

        <el-form-item v-if="searchType === '4'">
          <el-date-picker
            v-model="search.registerRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="timestamp"
            unlink-panels
            clearable
          />
        </el-form-item>

        <el-form-item v-if="searchType === '5'">
          <el-select v-model="search.app_id" placeholder="请选择平台" clearable filterable>
            <el-option v-for="item in appList" :key="item.id" :label="item.name || item.app_name || item.id" :value="item.id" />
          </el-select>
        </el-form-item>

        <el-form-item v-if="searchType === '6'">
          <el-select v-model="search.disabled" placeholder="请选择状态" clearable>
            <el-option label="启用" :value="0" />
            <el-option label="锁定" :value="1" />
          </el-select>
        </el-form-item>

        <!-- 渠道商自动完成（显示名称、内部传 ID） -->
        <el-form-item label="渠道商:">
          <el-autocomplete
            v-model="search.channel_id"
            :fetch-suggestions="queryChannel"
            placeholder="渠道商"
            clearable
            style="width: 200px;"
            @select="handleChannelSelect"
          >
            <template slot-scope="{ item }">
              <div>{{ item.realname }} {{ item.alias ? '(' + item.alias + ')' : '' }}</div>
            </template>
          </el-autocomplete>
        </el-form-item>

        <el-form-item class="search-actions">
          <el-button type="primary" size="small" @click="handleSearch">搜索</el-button>
          <el-button size="small" @click="handleReset">全部</el-button>
          <el-button
            type="primary"
            size="small"
            icon="el-icon-plus"
            @click="handleCreateUser"
          >添加会员</el-button>
          <el-button size="small" icon="el-icon-download" @click="handleExport">导出当前列表</el-button>
        </el-form-item>
      </el-form>

      <!-- 列表 -->
      <el-table :data="tableData" v-loading="loading" border size="small" style="width: 100%;" :header-cell-style="{background:'#fafafa'}">
        <el-table-column type="selection" width="60" />
        <el-table-column label="公司" prop="company_name" min-width="220" show-overflow-tooltip align="center" />
        <el-table-column label="用户名" prop="username" min-width="120" align="center" />
        <el-table-column label="手机号" prop="mobile" width="120" align="center" />
        <el-table-column label="平台名称" prop="app_name" width="180" :formatter="appNameFormat" align="center" />
        <el-table-column label="可用优惠券" prop="coupon_available" width="120" align="center" />
        <el-table-column label="注册渠道" prop="register_channel_id" min-width="160" :formatter="channelNameFormat" show-overflow-tooltip align="center" />
        <el-table-column label="用户角色" prop="role" width="100" :formatter="roleFormat" align="center" />
        <el-table-column label="用户类型" prop="parent_id" width="100" :formatter="userTypeFormat" align="center" />
        <el-table-column label="注册时间" prop="created_at" width="160" :formatter="dateFormat" align="center" />
        <el-table-column label="状态" prop="disabled" width="100" :formatter="statusFormat" align="center" />
        <el-table-column label="操作" width="460" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="handleShowDetail(scope.row)">详情</el-button>
            <el-divider direction="vertical" />
            <el-button type="text" size="mini" @click="handleToggleDisabled(scope.row)">{{ scope.row.disabled ? '启用' : '锁定' }}</el-button>
            <el-divider direction="vertical" />
            <el-button type="text" size="mini" @click="handleResetPassword(scope.row)">重置密码</el-button>
            <el-divider direction="vertical" />
            <el-button type="text" size="mini" @click="handleEditUser(scope.row)">编辑</el-button>
            <el-divider direction="vertical" />
            <el-button type="text" size="mini" @click="handleAddChild(scope.row)" :disabled="!!(scope.row.parent_id && scope.row.parent_id > 0)">添加子账户</el-button>
            <el-divider direction="vertical" />
            <el-button type="text" size="mini" @click="handleOpenChangeChannel(scope.row)">变更渠道</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-wrap">
        <el-pagination
          background
          layout="prev, pager, next, sizes, total"
          :page-size="pager.size"
          :current-page="pager.page"
          :total="pager.total"
          :page-sizes="[10,20,50,100]"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        />
      </div>
    </el-card>

    <!-- 详情对话框 -->
    <el-dialog title="用户详情" :visible.sync="detailDialogVisible" width="860px">
      <div class="detail-top" v-if="detail">
        <el-row :gutter="16" class="top-row">
          <el-col :span="8">
            <div class="label">公司名称：</div>
            <div class="value">
              <el-link type="primary" @click="openCompanyDetail(detail.company_id)">{{ detail.company_name }}</el-link>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="label">账号状态：</div>
            <div class="value">{{ detail.disabled ? '禁用' : '使用中' }}</div>
          </el-col>
          <el-col :span="8">
            <div class="label">公司地址：</div>
            <div class="value">{{ detail.company_address }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="16" class="top-row">
          <el-col :span="8">
            <div class="label">手机号：</div>
            <div class="value">{{ detail.mobile }}</div>
          </el-col>
          <el-col :span="8">
            <div class="label">邮箱：</div>
            <div class="value">{{ detail.email }}</div>
          </el-col>
          <el-col :span="8">
            <div class="label">注册时间：</div>
            <div class="value">{{ dateFormat(detail.created_at) }}</div>
          </el-col>
        </el-row>
      </div>

      <div class="address-section">
        <el-divider content-position="left">用户收件地址</el-divider>
        <div class="address-toolbar">
          <el-button type="danger" size="mini" @click="handleAddAddress" class="add-address-btn">添加邮寄地址</el-button>
        </div>
        <el-table :data="addressList" size="mini" border>
          <el-table-column prop="recipients" label="收件人" width="120" align="center" />
          <el-table-column prop="mobile" label="收件人手机号" width="140" align="center" />
          <el-table-column prop="phone" label="座机" width="140" align="center" />
          <el-table-column label="详细地址" min-width="360" align="center">
            <template slot-scope="scope">
              {{ formatFullAddress(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column label="默认地址" width="100" align="center">
            <template slot-scope="scope">
              {{ isDefaultText(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="handleEditAddress(scope.row)">编辑</el-button>
              <el-button type="text" size="mini" @click="handleDeleteAddress(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailDialogVisible=false">关闭</el-button>
      </span>
    </el-dialog>
    
    <!-- 添加邮寄地址 -->
    <el-dialog title="添加邮寄地址" :visible.sync="addAddressDialogVisible" width="600px">
      <el-form ref="addAddressForm" :model="addAddressForm" :rules="addAddressRules" label-width="100px" size="small">
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="收件人" prop="recipients">
              <el-input v-model="addAddressForm.recipients" placeholder="请输入收件人" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号" prop="mobile">
              <el-input v-model="addAddressForm.mobile" placeholder="请输入手机号" maxlength="11" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="座机">
              <el-input v-model="addAddressForm.phone" placeholder="请输入座机" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="默认地址">
              <el-switch v-model="addAddressForm.is_primary" active-text="是" inactive-text="否" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="24">
            <el-form-item label="省市区">
              <el-cascader
                v-model="regionValue"
                :options="regionOptions"
                :props="regionProps"
                placeholder="请选择省/市/区"
                filterable
                clearable
                @change="onRegionChange"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="详细地址" prop="street">
          <el-input type="textarea" :rows="2" v-model="addAddressForm.street" placeholder="请输入详细地址" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addAddressDialogVisible=false">取消</el-button>
        <el-button type="primary" @click="submitAddAddress">确 定</el-button>
      </span>
    </el-dialog>
    <CreateUser
      :visible.sync="showCreateDialog"
      @success="handleCreateSuccess"
      @close="handleCreateClose"
    />
    <!-- 编辑用户 -->
    <EditUser
      :visible.sync="editDialogVisible"
      :userData="editUserData"
      @success="handleEditUserSuccess"
      @close="editDialogVisible = false"
    />

    <!-- 添加子账户 -->
    <AddChildUser
      :visible.sync="addChildDialogVisible"
      :parentUserData="addChildUserData"
      @success="handleAddChildSuccess"
      @close="addChildDialogVisible = false"
    />

    <!-- 变更渠道 -->
    <ChangeChannel
      :visible.sync="changeChannelDialogVisible"
      :userId="changeChannelUserId"
      :appId="changeChannelAppId"
      @success="fetchData"
    />
  </div>
  
</template>

<script>
import { cmnUserList, disabledCmnUser, updateCmnUser, getAppList, getChannelList, getUserInfo, getUserAddressList, addUserAddress, deleteUserAddress } from '@/api/member'
import ChangeChannel from '@/views/MemberManage/components/ChangeChannel.vue'
import EditUser from '@/views/MemberManage/spbComponents/EditUser.vue'
import AddChildUser from '@/views/MemberManage/components/AddChildUser.vue'
import CreateUser from '@/views/MemberManage/components/CreateUser.vue'
import { getProvinceList, getCityList } from '@/api/product'
import CITIES_DATA from '@/lib/cities-data'

export default {
  name: 'MemberManage',
  components: { ChangeChannel, EditUser, AddChildUser, CreateUser },
  data() {
    return {
      loading: false,
      tableData: [],
      pager: { page: 1, size: 20, total: 0 },
      searchType: '1',
      search: {
        company_name: '',
        username: '',
        mobile: '',
        app_id: null,
        channel_id: '',
        channel_name: '',
        disabled: null,
        registerRange: [],
      },
      appList: [],
      channelMap: {},
      channelList: [],
      detailDialogVisible: false,
      detail: null,
      addressList: [],
      selectedChannel: null,
      channelKeyword: '',
      // 操作对话框状态
      editDialogVisible: false,
      showCreateDialog: false,
      editUserData: {},
      addChildDialogVisible: false,
      addChildUserData: {},
      changeChannelDialogVisible: false,
      changeChannelUserId: null,
      changeChannelAppId: null,
      // 添加邮寄地址
      addAddressDialogVisible: false,
      addAddressForm: {
        recipients: '',
        mobile: '',
        phone: '',
        province: '',
        city: '',
        district: '',
        street: '',
        is_primary: false
      },
      addAddressRules: {
        recipients: [{ required: true, message: '请输入收件人', trigger: 'blur' }],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^\d{11}$/, message: '手机号需为11位数字', trigger: 'blur' }
        ],
        province: [{ required: true, message: '请输入省份', trigger: 'blur' }],
        city: [{ required: true, message: '请输入城市', trigger: 'blur' }],
        district: [{ required: true, message: '请输入区县', trigger: 'blur' }],
        street: [{ required: true, message: '请输入详细地址', trigger: 'blur' }]
      },
      // 级联选择器（一次性加载静态省/市/区数据）
      regionOptions: [],
      regionValue: [],
      regionProps: {
        expandTrigger: 'hover',
        checkStrictly: false,
        emitPath: true,
        value: 'value',
        label: 'label'
      }
    }
  },
  created() {
    this.fetchAppList()
    this.fetchChannelMap()
    this.fetchData()
  },
  methods: {
    async fetchAppList() {
      try {
        const res = await getAppList({})
        if (res && res.err_code === 0) {
          this.appList = res.rows || res.data || []
        }
      } catch (e) {
        // ignore
      }
    },
    // 将项目内行政区划数据转换为使用名称作为值的 Cascader 选项
    buildRegionOptions() {
      if (!Array.isArray(CITIES_DATA)) return []
      const options = CITIES_DATA.map(p => ({
        label: p.label,
        value: p.label,
        children: (p.children || []).map(c => ({
          label: c.label,
          value: c.label,
          children: (c.children || []).map(a => ({
            label: a.label,
            value: a.label,
            leaf: true
          }))
        }))
      }))
      return options
    },
    // 级联选择变化时写回表单的省市区
    onRegionChange(val) {
      if (Array.isArray(val) && val.length >= 3) {
        this.addAddressForm.province = val[0]
        this.addAddressForm.city = val[1]
        this.addAddressForm.district = val[2]
      } else if (Array.isArray(val) && val.length === 2) {
        this.addAddressForm.province = val[0]
        this.addAddressForm.city = val[1]
        this.addAddressForm.district = ''
      } else if (Array.isArray(val) && val.length === 1) {
        this.addAddressForm.province = val[0]
        this.addAddressForm.city = ''
        this.addAddressForm.district = ''
      } else {
        this.addAddressForm.province = ''
        this.addAddressForm.city = ''
        this.addAddressForm.district = ''
      }
    },
    async fetchChannelMap() {
      try {
        const res = await getChannelList()
        const list = res.rows || res.data || []
        this.channelList = list
        const map = {}
        list.forEach(item => {
          const name = item.realname || item.name || ''
          const alias = item.alias || ''
          const label = alias ? `${name}(${alias})` : name
          if (item.id !== undefined && item.id !== null) {
            map[item.id] = label || String(item.id)
          }
        })
        this.channelMap = map
      } catch (error) {
        console.error('获取渠道列表失败:', error)
        this.channelMap = {}
        this.channelList = []
      }
    },
    queryChannel(queryString, cb) {
      if (!queryString) {
        cb(this.channelList)
        return
      }
      const searchText = queryString.toLowerCase()
      const results = this.channelList.filter(channel => {
        return (channel.realname && channel.realname.toLowerCase().includes(searchText)) ||
               (channel.name && channel.name.toLowerCase().includes(searchText)) ||
               (channel.alias && channel.alias.toLowerCase().includes(searchText))
      })
      cb(results)
    },
    handleChannelSelect(item) {
      this.selectedChannel = item
      this.search.channel_id = item.realname + (item.alias ? '(' + item.alias + ')' : '')
    },
    handleSearch() {
      this.pager.page = 1
      this.fetchData()
    },
    // 创建用户
    handleCreateUser() {
      this.showCreateDialog = true
    },
    // 创建用户成功回调
    handleCreateSuccess() {
      // 重新加载数据
      this.fetchData()
    },
    
    // 创建用户关闭回调
    handleCreateClose() {
      this.showCreateDialog = false
    },
    handleReset() {
      this.search = { company_name: '', username: '', mobile: '', app_id: null, channel_id: '', channel_name: '', disabled: null, registerRange: [] }
      this.channelKeyword = ''
      this.selectedChannel = null
      this.searchType = '1'
      this.pager.page = 1
      this.fetchData()
    },
    // 搜索类型变化时重置对应字段，避免多条件叠加
    handleSearchTypeChange() {
      this.search.company_name = ''
      this.search.username = ''
      this.search.mobile = ''
      this.search.registerRange = []
      this.search.app_id = null
      this.search.disabled = null
    },
    async fetchData() {
      this.loading = true
      try {
        const params = {
          page: this.pager.page,
          rows: this.pager.size,
          company_name: this.search.company_name || undefined,
          username: this.search.username || undefined,
          mobile: this.search.mobile || undefined,
          app_id: this.search.app_id || undefined,
          // 避免 selectedChannel 为 null 时访问 .id 报错
          register_channel_id: (this.selectedChannel && this.selectedChannel.id) || undefined,
          disabled: this.search.disabled,
          role: 1,
        }
        if (this.search.registerRange && this.search.registerRange.length === 2) {
          const [begin, end] = this.search.registerRange
          params.begin_time = Math.floor(begin / 1000)
          params.end_time = Math.floor(end / 1000)
        }
        const res = await cmnUserList(params)
        if (res && res.err_code === 0) {
          const list = res.rows || res.list || []
          const total = res.total || res.count || list.length
          this.tableData = list
          this.pager.total = total
        }
      } catch (e) {
        // ignore
      } finally {
        this.loading = false
      }
    },
    handleSizeChange(size) {
      this.pager.size = size
      this.fetchData()
    },
    handlePageChange(page) {
      this.pager.page = page
      this.fetchData()
    },
    // formatter: 日期（兼容表格回调与直接调用）
    dateFormat(row, column, cellValue) {
      const value = (column === undefined) ? row : cellValue
      if (!value && value !== 0) return ''
      let ts = value
      if (typeof ts === 'string') {
        const num = Number(ts)
        if (!Number.isNaN(num)) ts = num
        else {
          const d = new Date(ts)
          if (!isNaN(d.getTime())) ts = d.getTime()
        }
      }
      if (typeof ts === 'number') {
        if (ts < 1e12) ts = ts * 1000
      }
      const d = new Date(ts)
      if (isNaN(d.getTime())) return ''
      const y = d.getFullYear()
      if (y < 1971) return ''
      const pad = (n) => (n < 10 ? '0' + n : '' + n)
      return `${y}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
    },
    // formatter: 状态（兼容表格回调与直接调用）
    statusFormat(row, column, cellValue) {
      const value = (column === undefined) ? row : cellValue
      const v = (typeof value === 'string') ? Number(value) : value
      const disabled = !!v
      return disabled ? '锁定' : '启用'
    },
    // formatter: 平台名称
    appNameFormat(row, column, value) {
      const name = row.app_name || value
      if (name) return name
      const id = row.app_id
      const item = this.appList.find(i => i.id === id)
      return (item && (item.name || item.app_name)) || (id == null ? '' : String(id))
    },
    // formatter: 渠道名称
    channelNameFormat(row, column, value) {
      const id = row.register_channel_id != null ? row.register_channel_id : (row.channel_id != null ? row.channel_id : null)
      if (id == null) return row.channel_name || ''
      return this.channelMap[id] || row.channel_name || String(id)
    },
    // formatter: 角色
    roleFormat(row, column, value) {
      const v = (typeof value === 'string') ? Number(value) : value
      if (v === 1) return '普通用户'
      if (v === 2) return '渠道代理'
      if (v > 4) return '管理用户'
      return ''
    },
    // formatter: 用户类型
    userTypeFormat(row, column, value) {
      const v = (typeof value === 'string') ? Number(value) : value
      return (v && v > 0) ? '子账号' : '主账号'
    },
    async handleToggleDisabled(row) {
      const target = !row.disabled
      try {
        await this.$confirm(`确认要${target ? '锁定' : '启用'}该用户吗？`, '提示', { type: 'warning' })
      } catch (e) {
        return
      }
      try {
        await disabledCmnUser({ user_id: row.id, disabled: target})
        this.$message.success(`${target ? '锁定' : '启用'}成功`)
        this.fetchData()
      } catch (e) {
        this.$message.error('操作失败')
      }
    },
    async handleResetPassword(row) {
      try {
        await this.$confirm(`确认重置该用户的登录密码为默认值？`, '提示', { type: 'warning' })
      } catch (e) {
        return
      }
      try {
        await updateCmnUser({ id: row.id, login_password: 'jubao32156' })
        this.$message.success('密码已重置为默认值')
      } catch (e) {
        this.$message.error('重置失败')
      }
    },
    async handleShowDetail(row) {
      try {
        const [infoRes, addrRes] = await Promise.all([
          getUserInfo({ id: row.id }),
          getUserAddressList({ id: row.id })
        ])
        this.detail = (infoRes && infoRes.data) || row
        this.addressList = (addrRes && (addrRes.rows || addrRes.data || []) ) || []
        this.detailDialogVisible = true
      } catch (e) {
        this.$message.error('获取详情失败')
      }
    },
    // 公司详情（占位：与老项目一致，点击打开公司详情页）
    openCompanyDetail(companyId) {
      if (!companyId) return
      this.$message.info('公司详情：后续接入公司详情视图或路由')
    },
    // 地址显示：拼接省市区街道
    formatFullAddress(row) {
      const p = row.province || ''
      const c = row.city || ''
      const d = row.district || ''
      const s = row.street || row.address || ''
      return `${p}${c}${d}${s}`
    },
    // 默认地址显示
    isDefaultText(row) {
      const v = row.is_primary != null ? row.is_primary : (row.is_default != null ? row.is_default : false)
      return v ? '是' : '否'
    },
    // 添加邮寄地址：打开表单弹框
    handleAddAddress() {
      if (!this.detail || !this.detail.id) {
        this.$message.warning('请先打开用户详情')
        return
      }
      // 重置表单
      this.addAddressForm = {
        recipients: '',
        mobile: this.detail.mobile || '',
        phone: '',
        province: '',
        city: '',
        district: '',
        street: '',
        is_primary: false
      }
      this.regionValue = []
      // 一次性加载静态省市区
      try {
        const opts = this.buildRegionOptions()
        if (opts && opts.length) {
          this.regionOptions = opts
        } else {
          this.regionOptions = []
          console.warn('项目内静态地址数据未加载或为空')
        }
      } catch (e) {
        this.regionOptions = []
        console.error('构建静态省市区失败', e)
      }
      this.addAddressDialogVisible = true
    },
    // 提交新增地址
    submitAddAddress() {
      this.$refs.addAddressForm.validate(async (valid) => {
        if (!valid) return
        try {
          const payload = {
            user_id: this.detail.id,
            recipients: this.addAddressForm.recipients,
            mobile: this.addAddressForm.mobile,
            phone: this.addAddressForm.phone,
            province: this.addAddressForm.province,
            city: this.addAddressForm.city,
            district: this.addAddressForm.district,
            street: this.addAddressForm.street,
            is_primary: this.addAddressForm.is_primary ? 1 : 0
          }
          const res = await addUserAddress(payload)
          if (res && res.err_code === 0) {
            this.$message.success('地址添加成功')
            this.addAddressDialogVisible = false
            // 刷新地址列表
            try {
              const addrRes = await getUserAddressList({ id: this.detail.id })
              this.addressList = (addrRes && (addrRes.rows || addrRes.data || []) ) || []
            } catch (e) {}
          } else {
            this.$message.error('添加失败')
          }
        } catch (error) {
          this.$message.error('添加失败：' + (error && error.message || ''))
        }
      })
    },
    // 删除邮寄地址
    async handleDeleteAddress(row) {
      try {
        await this.$confirm('确认删除该邮寄地址？', '提示', { type: 'warning' })
      } catch (e) { return }
      try {
        const res = await deleteUserAddress({ id: row.id })
        if (res && res.err_code === 0) {
          this.$message.success('删除成功')
          // 刷新地址列表
          const addrRes = await getUserAddressList({ id: this.detail.id })
          this.addressList = (addrRes && (addrRes.rows || addrRes.data || []) ) || []
        } else {
          this.$message.error('删除失败')
        }
      } catch (error) {
        this.$message.error('删除失败：' + (error && error.message || ''))
      }
    },
    // 编辑邮寄地址（占位）
    handleEditAddress(row) {
      this.$message.info('编辑地址：待接入 /v1/admin/cmn/useraddress/update 接口')
    },
    // 删除邮寄地址（占位）
    async handleDeleteAddress(row) {
      try {
        await this.$confirm('确认删除该邮寄地址？', '提示', { type: 'warning' })
      } catch (e) { return }
      this.$message.info('删除地址：待接入 /v1/admin/cmn/useraddress/delete 接口')
    },
    // 编辑（占位）
    handleEditUser(row) {
      this.editUserData = row
      this.editDialogVisible = true
    },
    handleEditUserSuccess() {
      this.editDialogVisible = false
      this.fetchData() // 刷新列表数据
    },
    // 添加子账户（仅主账号可用）
    handleAddChild(row) {
      if (row.parent_id && row.parent_id > 0) {
        this.$message.info('子账号不可再添加子账户')
        return
      }
      this.addChildUserData = row
      this.addChildDialogVisible = true
    },
    handleAddChildSuccess() {
      this.addChildDialogVisible = false
      this.fetchData() // 刷新列表数据
    },
    // 打开变更渠道
    handleOpenChangeChannel(row) {
      this.changeChannelUserId = row.id
      this.changeChannelAppId = row.app_id
      this.changeChannelDialogVisible = true
    },
    handleExport() {
      const headers = ['用户ID','用户名','手机号','公司名称','渠道商','所属App','注册时间','状态']
      const rows = this.tableData.map(r => [
        r.id,
        r.username,
        r.mobile,
        r.company_name,
        r.channel_name,
        r.app_id,
        this.dateFormat(r.created_at),
        this.statusFormat(r.disabled)
      ])
      const csv = [headers.join(','), ...rows.map(x => x.map(v => {
        const s = (v == null ? '' : String(v)).replace(/"/g,'""')
        return `"${s}"`
      }).join(','))].join('\n')
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = `会员列表_${Date.now()}.csv`
      a.click()
      URL.revokeObjectURL(url)
    }
  }
}
</script>

<style lang="less" scoped>
.member-manage {
  padding: 16px;
}
.search-form {
  margin-bottom: 12px;
}
.pagination-wrap {
  margin-top: 12px;
  text-align: right;
}
.section-title {
  margin: 12px 0 8px;
  font-weight: 600;
}
.user-detail-desc {
  margin-bottom: 12px;
}
.detail-top {
  padding: 8px 6px 0;
}
.detail-top .label {
  display: inline-block;
  width: 90px;
  text-align: right;
  font-weight: 600;
}
.detail-top .value {
  display: inline-block;
  margin-left: 8px;
  color: #333;
}
.top-row {
  margin-bottom: 8px;
}
.address-section {
  margin-top: 10px;
}
.address-toolbar {
  text-align: right;
  margin-bottom: 8px;
}
.add-address-btn {
  width: 100px;
}
.user-detail-desc ::v-deep .el-descriptions-item__label {
  font-weight: 600;
  color: #606266;
}
.user-detail-desc ::v-deep .el-descriptions-item__content {
  color: #333;
}
.address-list {
  margin-top: 8px;
}
</style>
